module.exports = __webpack_public_path__ + "img/Hubei-speed.fae92bae.png";